import styled from 'styled-components'

const IconBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: calc(100vh - 85px);
`

const Icon = styled.i`
  font-size: 50px;
  color: #f2662e;
`

export { Icon, IconBox }
